/**
 * cart-mini-gift.js v2 (su debug logging)
 *
 * Auto-add / auto-remove a gift line item based on cart subtotal threshold.
 *
 * Debug: atidaryk browser console (F12) — visos žinutės prasideda [cart-gift].
 * Jei nori labai išsamaus log'o, console įvesk: window.__CART_GIFT_DEBUG = true
 */

(function () {
  'use strict';

  const LOG_PREFIX = '[cart-gift]';
  const SESSION_REMOVED_KEY = 'cart_gift_user_removed';

  const state = {
    reconciling: false,
    config: null,
    inFlight: 0,
  };

  function log(...args) {
    console.log(LOG_PREFIX, ...args);
  }
  function warn(...args) {
    console.warn(LOG_PREFIX, ...args);
  }
  function debug(...args) {
    if (window.__CART_GIFT_DEBUG) console.log(LOG_PREFIX, '[debug]', ...args);
  }

  function readConfig() {
    const giftEl = document.querySelector('cart-mini-gift[data-variant-id]');
    const barEl = document.querySelector('cart-progress-bar[data-gift-threshold]');

    if (!giftEl && !barEl) {
      warn('No <cart-mini-gift> ar <cart-progress-bar> elementas DOM\'e. Ar Customize → Cart settings sukonfigūruoti? Ar snippet\'ai įdėti į cart sekcijas?');
      return null;
    }

    let variantId = 0;
    if (giftEl && giftEl.dataset.variantId) {
      variantId = parseInt(giftEl.dataset.variantId, 10);
    }

    let thresholdCents = 0;
    if (giftEl && giftEl.dataset.threshold) {
      thresholdCents = parseInt(giftEl.dataset.threshold, 10);
    } else if (barEl && barEl.dataset.giftThreshold) {
      thresholdCents = parseInt(barEl.dataset.giftThreshold, 10);
    }

    if (!variantId) {
      warn('Trūksta dovanos produkto. Customize → Theme settings → Cart → Mini dovana → pasirink dovanos produktą.');
      return null;
    }
    if (!thresholdCents) {
      warn('Trūksta dovanos slenksčio. Customize → Theme settings → Cart → Mini dovanos slenkstis.');
      return null;
    }

    debug('Config:', { variantId, thresholdCents });
    return { variantId, thresholdCents };
  }

  function isGiftItem(item) {
    if (!item || !item.properties) return false;
    return item.properties._is_gift === 'true' || item.properties._is_gift === true;
  }

  function computeSubtotal(cart) {
    let subtotal = 0;
    for (const item of cart.items) {
      if (isGiftItem(item)) continue;
      subtotal += item.original_line_price;
    }
    if (cart.cart_level_discount_applications) {
      for (const d of cart.cart_level_discount_applications) {
        subtotal -= d.total_allocated_amount;
      }
    }
    return subtotal;
  }

  async function fetchCart() {
    const resp = await window.__origFetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
    });
    if (!resp.ok) throw new Error('Cart fetch failed: ' + resp.status);
    return resp.json();
  }

  async function addGift(variantId) {
    log('Pridedam dovaną variant_id=' + variantId);
    const resp = await window.__origFetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Cart-Gift': '1',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { '_is_gift': 'true' },
        }],
      }),
    });
    if (!resp.ok) {
      const txt = await resp.text();
      throw new Error('Add gift failed: ' + resp.status + ' ' + txt);
    }
    log('Dovana pridėta ✓');
    return resp.json();
  }

  async function removeGift(key) {
    log('Šaliname dovaną key=' + key);
    const resp = await window.__origFetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Cart-Gift': '1',
      },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    if (!resp.ok) throw new Error('Remove gift failed: ' + resp.status);
    log('Dovana pašalinta ✓');
    return resp.json();
  }

  async function refreshCartSections() {
    const sectionIds = ['mini-cart', 'main-cart'].filter((id) =>
      document.getElementById('shopify-section-' + id)
    );
    if (sectionIds.length === 0) {
      debug('Nieko nerefreshinom — joks shopify-section-* elementas nerastas');
      return;
    }

    try {
      const resp = await window.__origFetch('/?sections=' + sectionIds.join(','));
      if (!resp.ok) throw new Error('Sections fetch failed');
      const data = await resp.json();

      for (const id of sectionIds) {
        if (!data[id]) continue;
        const current = document.getElementById('shopify-section-' + id);
        if (!current) continue;
        const parser = new DOMParser();
        const doc = parser.parseFromString(data[id], 'text/html');
        const updated = doc.getElementById('shopify-section-' + id);
        if (updated) {
          current.replaceWith(updated);
          debug('Atnaujinom sekciją:', id);
        }
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      warn('Section refresh nepavyko:', err);
    }
  }

  async function reconcile() {
    if (state.reconciling) {
      debug('Reconcile praleistas — jau vykdomas');
      return;
    }
    const config = state.config || readConfig();
    if (!config) return;

    state.reconciling = true;
    try {
      const cart = await fetchCart();
      const giftItem = cart.items.find(isGiftItem);
      const subtotal = computeSubtotal(cart);
      const userRemoved = sessionStorage.getItem(SESSION_REMOVED_KEY) === '1';

      debug('Reconcile:', {
        subtotal,
        threshold: config.thresholdCents,
        hasGift: !!giftItem,
        userRemoved,
      });

      if (subtotal >= config.thresholdCents && !giftItem && !userRemoved) {
        log('Slenkstis pasiektas (' + (subtotal / 100) + '€ >= ' + (config.thresholdCents / 100) + '€) → pridedam dovaną');
        await addGift(config.variantId);
        await refreshCartSections();
      } else if (subtotal < config.thresholdCents && giftItem) {
        log('Krepšelis nukrito žemiau slenksčio (' + (subtotal / 100) + '€ < ' + (config.thresholdCents / 100) + '€) → šaliname dovaną');
        await removeGift(giftItem.key);
        await refreshCartSections();
        sessionStorage.removeItem(SESSION_REMOVED_KEY);
      } else {
        debug('Reconcile: jokių pakeitimų nereikia');
      }
    } catch (err) {
      console.error(LOG_PREFIX, 'Reconcile klaida:', err);
    } finally {
      state.reconciling = false;
    }
  }

  function scheduleReconcile() {
    setTimeout(reconcile, 120);
  }

  function installFetchInterceptor() {
    if (window.__origFetch) return;
    window.__origFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      let isInternal = false;
      if (init && init.headers) {
        if (init.headers['X-Cart-Gift']) isInternal = true;
        if (init.headers.get && init.headers.get('X-Cart-Gift')) isInternal = true;
      }
      const isCartMutation = /\/cart\/(add|change|update|clear)(\.js|$|\?)/.test(url);

      const promise = window.__origFetch(input, init);

      if (isCartMutation && !isInternal) {
        debug('Cart mutation detected:', url);
        promise.then(function (resp) {
          if (resp && resp.ok !== false) scheduleReconcile();
        }).catch(function () {});
      }

      return promise;
    };

    debug('Fetch interceptor įdiegtas');
  }

  function detectUserGiftRemoval() {
    document.addEventListener('click', function (event) {
      const removeLink = event.target.closest('a[href*="/cart/change"]');
      if (!removeLink) return;
      const href = removeLink.getAttribute('href') || '';
      if (!/quantity=0/.test(href)) return;

      const lineItem = removeLink.closest('line-item, .line-item, tr.line-item');
      if (!lineItem) return;

      const isGiftLine = lineItem.querySelector('[data-is-gift="true"]') ||
        /_is_gift/.test(lineItem.innerHTML);
      if (isGiftLine) {
        log('Vartotojas pats pašalino dovaną — neauto-add\'insim šios sesijos metu');
        sessionStorage.setItem(SESSION_REMOVED_KEY, '1');
      }
    }, true);
  }

  function init() {
    log('Initializing...');
    state.config = readConfig();
    installFetchInterceptor();
    detectUserGiftRemoval();

    if (state.config) {
      log('Config OK:', state.config);
      scheduleReconcile();
    } else {
      warn('Config netinkamas — auto-add neveiks. Patikrink: 1) Customize → Cart → Mini dovana ar nustatyta; 2) ar cart-mini-gift snippet įdėtas į mini-cart.liquid ir main-cart.liquid.');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:refresh', function () {
    state.config = readConfig();
  });

  if (!customElements.get('cart-mini-gift')) {
    customElements.define('cart-mini-gift', class extends HTMLElement {});
  }
  if (!customElements.get('cart-progress-bar')) {
    customElements.define('cart-progress-bar', class extends HTMLElement {});
  }
})();
